import { render, staticRenderFns } from "./theylive.vue?vue&type=template&id=05fb1378&scoped=true"
import script from "./theylive.vue?vue&type=script&lang=js"
export * from "./theylive.vue?vue&type=script&lang=js"
import style0 from "./theylive.styl?vue&type=style&index=0&id=05fb1378&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb1378",
  null
  
)

export default component.exports